var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakeYourOwnMoneyIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "make_your_own_money_icn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 56.7567568,
    y: 29.5135135,
    width: 27.2432432,
    height: 22.7027027,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 23.5,
    cy: 67.5,
    r: 13.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "make_your_own_money_icn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-icon",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7218617,6.81081081 L8.15429415,6.81081081",
    id: "Path-4-Copy",
    stroke: "#AFB1B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1081081,13.6216216 L7.94594595,13.6216216 C4.184439,13.6216216 1.13513514,10.5723178 1.13513514,6.81081081 C1.13513514,3.04930387 4.184439,0 7.94594595,0 L71.5135135,0",
    id: "Rectangle-2",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9137416,33.4297967 L-28.9831899,37.0623579 C-28.0078959,37.7750808 -26.8169351,38.1786272 -25.5570056,38.1786272 L31.1997512,38.1786272 C34.0462583,38.1786272 36.4147227,36.1318828 36.9137416,33.4297967 Z",
    id: "Rectangle-2",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    transform: "translate(3.405405, 35.773222) rotate(90.000000) translate(-3.405405, -35.773222) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3783784,61.920834 L86.4054054,57.5718232 L86.4054054,30.0810811 C86.4054054,25.6180232 82.7873822,22 78.3243243,22 L37.4594595,22 C32.9964016,22 29.3783784,25.6180232 29.3783784,30.0810811 L29.3783784,61.920834 Z",
    id: "Rectangle-2",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    transform: "translate(57.891892, 42.000000) rotate(90.000000) translate(-57.891892, -42.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2E2D2E",
    strokeWidth: 2,
    x: 57.7567568,
    y: 30.5135135,
    width: 25.2432432,
    height: 20.7027027,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#AFB1B3",
    strokeWidth: 1.7,
    cx: 23.5,
    cy: 67.5,
    r: 12.65
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#AFB1B3",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    points: "24 62 24 69.055186 28 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7027027,36.8918919 L64.7027027,46.0436439",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeYourOwnMoneyIcn);
export default __webpack_public_path__ + "static/media/make_your_own_money_icn.69058169fa685d7c632a08552ad5d471.svg";
export { ForwardRef as ReactComponent };